<button mat-button [disabled]="disabled" (click)="gLogout()" class="error">
  <mat-icon> logout </mat-icon>
  <span>{{ buttonText | siaTranslate }}</span>
</button>
